
export const DueDateText = 'Date d\'échéance';
export const NumberText = 'No.';
export const AmountWoTaxText = 'Montant HT';
export const AmountTTCText = 'Montant TTC';
export const BuyerName = 'Acheteur';
export const SellerName = 'Vendeur';
